import resourceApi from '../../api/resource';
import moment from 'moment';

// initial state
const state = {
  resourceCategories: [],
  resources: [],
};

const getters = {};

const actions = {
  getAll({commit}) {
    resourceApi.getAll(resources => {
      commit('setResources', resources);
    });
  },

  getRoots({commit}) {
    resourceApi.getRoots(categories => {
      commit('setCategories', categories);
    });
  },

  create({dispatch, commit}, params) {
    return new Promise((resolve, reject) => {
      resourceApi.create(
        params,
        categories => {
          commit('setCategories', categories);
          // set resources
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  update({dispatch, commit}, resourceObject) {
    return new Promise((resolve, reject) => {
      resourceApi.update(
        resourceObject,
        categories => {
          commit('setCategories', categories);
          // set resources
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  destroy({dispatch, commit}, id) {
    return new Promise((resolve, reject) => {
      resourceApi.destroy(
        id,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  updateCategory({dispatch, commit}, categoryObject) {
    return new Promise((resolve, reject) => {
      resourceApi.updateCategory(
        categoryObject,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  moveCategoryHigher({dispatch, commit}, categoryObject) {
    return new Promise((resolve, reject) => {
      resourceApi.moveCategoryHigher(
        categoryObject,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  moveCategoryLower({dispatch, commit}, categoryObject) {
    return new Promise((resolve, reject) => {
      resourceApi.moveCategoryLower(
        categoryObject,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  destroyCategory({dispatch, commit}, id) {
    return new Promise((resolve, reject) => {
      resourceApi.destroyCategory(
        id,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },

  createCategory({dispatch, commit}, params) {
    return new Promise((resolve, reject) => {
      resourceApi.createCategory(
        params,
        categories => {
          commit('setCategories', categories);
          resolve();
        },
        error => {
          console.log('Something broke at the API');
          reject();
        },
      );
    });
  },
};

const mutations = {
  setResources(state, resources) {
    state.resources = resources;
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },
  setCategories(state, categories) {
    state.resourceCategories = categories;
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
